import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'unistore/react';

import core from '~/core/scripts';
import '../styles/index.styl';

import ElectionMap from './ElectionMap';
import store from './state/store';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

ReactDOM.render(
  <Provider store={store}>
    <ElectionMap />
  </Provider>,
  document.getElementById('map')
);

//setTimeout(function(){ location.reload(); }, 600000);

if (process.env.NODE_ENV === 'development') {
  require('file-loader!../index.html');
}
